import { api } from "@/utils/api";
import { Kpi, KpiPaginated } from "./Kpi";
import { sanitizePathParam } from "@/utils/sanitize";

export default class KpiRepository {
  async getKpi(organizationId: string, userId: string, locationId?: string): Promise<Kpi[]> {
    const oid = sanitizePathParam(organizationId);
    const uid = sanitizePathParam(userId);
    const kpis = await api.get(
      `/kpis/organizations/${oid}/users/${uid}/${locationId ? `?locationId=${encodeURIComponent(locationId)}` : ''}`
    );
    return kpis.data;
  }

  async getKpiByOrganization(
    organizationId: string,
    page: string | number = "1",
    size: string | number = "10",
    name?: string | null,
    enabled?: boolean | null,
    user?: string | null,
    location?: string | null
  ): Promise<KpiPaginated> {
    const oid = sanitizePathParam(organizationId);
    const kpis = await api.get(`kpis/organizations/${oid}`, {
      params: {
        page,
        size,
        name,
        enabled,
        user,
        location,
      },
    });
    return kpis.data;
  }

  async postKpi(
    name: string,
    enabled: boolean,
    parameterId: number,
    kpiId?: number
  ): Promise<boolean> {
    const response = await api.post(`kpis/`, {
      name,
      enabled,
      parameterId,
      kpiId,
    });
    return response.data;
  }

  async changeEnableKpi(
    kpiId: string | number,
    enabled: boolean
  ): Promise<boolean> {
    const kid = sanitizePathParam(kpiId);
    const response = await api.put(`kpis/${kid}/status?enabled=${enabled}`);
    return response.data;
  }

  async getKpiDetails(kpiId: number): Promise<any> {
    const kid = sanitizePathParam(kpiId);
    const kpi = await api.get(`/kpis/${kid}`);
    return kpi.data;
  }

  async postPinKpiInDashboard(kpiId: number, showBoard: boolean) {
    const kid = sanitizePathParam(kpiId);
    const response = await api.post(
      `users/kpis/${kid}?showBoard=${showBoard}`
    );
    return response.data;
  }

  async getKpisByUser(userId: string) {
    const uid = sanitizePathParam(userId);
    const kpis = await api.get(`users/${uid}/kpis`);
    return kpis.data;
  }

  async deleteKpi(kpiId: number) {
    const kid = sanitizePathParam(kpiId);
    const response = await api.delete(`kpis/${kid}`);
    return response.data;
  }
}
